<template>
    <Head title="Monitor ShelfPix" />
    <Authenticated>
        <Heading title="Monitor ShelfPix" class="px-4 pb:px-[16vw] xl:pt-24 pb:pb-8 sm:pl-6 pt-28" />
        <div class="component-background-desktop min-h-[70vh]">
            <div class="px-2.5 py-[35px] xl:px-[15vw]">
                <div class="flex items-center gap-x-4 mb-6">
                    <button
                        class="bg-primary text-white font-semibold px-4 py-2 rounded-lg hover:opacity-90 disabled:opacity-50 flex items-center gap-x-2"
                        :disabled="loadingProcess || loadingBucket"
                        @click="handleProcess"
                    >
                        <svg v-if="loadingProcess" class="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
                        </svg>
                        Processar D-1
                    </button>

                    <button
                        class="bg-secondary text-white font-semibold px-4 py-2 rounded-lg hover:opacity-90 disabled:opacity-50 flex items-center gap-x-2"
                        :disabled="loadingProcess || loadingBucket"
                        @click="handleProcessBucket"
                    >
                        <svg v-if="loadingBucket" class="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
                        </svg>
                        Processar Bucket
                    </button>

                    <span v-if="actionMessage" :class="actionMessageClass" class="text-sm font-medium">
                        {{ actionMessage }}
                    </span>
                </div>

                <div class="bg-white rounded-2xl overflow-hidden shadow">
                    <table class="w-full text-sm text-left">
                        <thead class="bg-gray-50 text-gray-600 uppercase text-xs">
                            <tr>
                                <th class="px-4 py-3">Data Início</th>
                                <th class="px-4 py-3">Data Fim</th>
                                <th class="px-4 py-3">Status</th>
                                <th class="px-4 py-3">Total Fotos</th>
                                <th class="px-4 py-3">Pendentes</th>
                                <th class="px-4 py-3">Enviadas</th>
                                <th class="px-4 py-3">Com Erro</th>
                                <th class="px-4 py-3">Criado em</th>
                            </tr>
                        </thead>
                        <tbody class="divide-y divide-gray-100">
                            <tr v-if="!plans.length">
                                <td colspan="8" class="px-4 py-6 text-center text-gray-400">Nenhum build plan encontrado.</td>
                            </tr>
                            <tr v-for="plan in plans" :key="plan.id" class="hover:bg-gray-50">
                                <td class="px-4 py-3">{{ formatDate(plan.startDate) }}</td>
                                <td class="px-4 py-3">{{ formatDate(plan.endDate) }}</td>
                                <td class="px-4 py-3">
                                    <span :class="statusBadgeClass(plan.processed)" class="px-2 py-1 rounded-full text-xs font-semibold">
                                        {{ statusLabel(plan.processed) }}
                                    </span>
                                </td>
                                <td class="px-4 py-3">{{ plan.total ?? 0 }}</td>
                                <td class="px-4 py-3">{{ plan.pending ?? 0 }}</td>
                                <td class="px-4 py-3">{{ plan.uploaded ?? 0 }}</td>
                                <td class="px-4 py-3">{{ plan.failed ?? 0 }}</td>
                                <td class="px-4 py-3">{{ formatDate(plan.createdAt) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </Authenticated>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3';
import Authenticated from '@/Layouts/Authenticated.vue';
import Heading from '@/Components/UI/Texts/Heading.vue';
import axios from 'axios';

export default {
    components: { Head, Authenticated, Heading },

    props: {
        buildPlans: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            plans: this.buildPlans || [],
            loadingProcess: false,
            loadingBucket: false,
            actionMessage: '',
            actionSuccess: true,
        };
    },

    computed: {
        actionMessageClass() {
            return this.actionSuccess ? 'text-green-600' : 'text-red-600';
        },
    },

    methods: {
        formatDate(value) {
            if (!value) return '-';
            return new Date(value).toLocaleString('pt-BR');
        },

        statusLabel(processed) {
            const labels = { 0: 'Pendente', 1: 'Selecionado', 2: 'Enviado', 3: 'Erro' };
            return labels[processed] ?? 'Desconhecido';
        },

        statusBadgeClass(processed) {
            const classes = {
                0: 'bg-gray-100 text-gray-700',
                1: 'bg-yellow-100 text-yellow-700',
                2: 'bg-green-100 text-green-700',
                3: 'bg-red-100 text-red-700',
            };
            return classes[processed] ?? 'bg-gray-100 text-gray-700';
        },

        handleProcess() {
            this.loadingProcess = true;
            this.actionMessage = '';
            axios.post(route('shelfpix.process'))
                .then((res) => {
                    this.actionSuccess = res.data?.success;
                    this.actionMessage = res.data?.success ? 'Processamento D-1 iniciado com sucesso.' : 'Falha ao iniciar processamento D-1.';
                    this.reload();
                })
                .catch(() => {
                    this.actionSuccess = false;
                    this.actionMessage = 'Erro ao chamar processamento D-1.';
                })
                .finally(() => {
                    this.loadingProcess = false;
                });
        },

        handleProcessBucket() {
            this.loadingBucket = true;
            this.actionMessage = '';
            axios.post(route('shelfpix.process-bucket'))
                .then((res) => {
                    this.actionSuccess = res.data?.success;
                    this.actionMessage = res.data?.success ? 'Processamento de bucket iniciado com sucesso.' : 'Falha ao iniciar processamento de bucket.';
                    this.reload();
                })
                .catch(() => {
                    this.actionSuccess = false;
                    this.actionMessage = 'Erro ao chamar processamento de bucket.';
                })
                .finally(() => {
                    this.loadingBucket = false;
                });
        },

        reload() {
            this.$inertia.reload({ only: ['buildPlans'], onSuccess: (page) => {
                this.plans = page.props.buildPlans || [];
            }});
        },
    },
};
</script>
